import { Form } from "react-bootstrap";

const LabResultForm = ({ formData, handleChange, showValidationError }) => {
  return (
    <>
      <Form.Group>
        <Form.Label className='fs-6 fw-semibold'>Technique Type:</Form.Label>
        <div className='mb-3'>
          <Form.Check
            inline
            type='radio'
            name='techniqueType'
            id='massSpectrometry'
            label='Mass Spectrometry'
            value='Mass Spectrometry'
            checked={formData.type === "Mass Spectrometry"}
            onChange={(e) => handleChange("type", e.target.value)}
          />
          <Form.Check
            inline
            type='radio'
            name='techniqueType'
            id='other'
            label='Other'
            value='Other'
            checked={formData.type === "Other"}
            onChange={(e) => handleChange("type", e.target.value)}
          />
          {showValidationError && !formData.type && (
            <div className='invalid-feedback d-block'>
              Please select a technique type.
            </div>
          )}
        </div>
      </Form.Group>

      {formData.type === "Other" && (
        <Form.Group>
          <Form.Label className='fs-6 fw-semibold'>Other Technique:</Form.Label>
          <Form.Control
            required
            className='mb-3'
            type='text'
            placeholder='Please specify'
            defaultValue={formData.otherTechniqueType}
            onChange={(e) => handleChange("otherTechniqueType", e.target.value)}
            isInvalid={showValidationError && !formData.otherTechniqueType}
          />
          {showValidationError && !formData.otherTechniqueType && (
            <Form.Control.Feedback type='invalid' className='d-block'>
              Please specify the other technique.
            </Form.Control.Feedback>
          )}
        </Form.Group>
      )}

      <Form.Group>
        <Form.Label className='fs-6 fw-semibold'>Results:</Form.Label>
        <Form.Control
          required
          className='mb-3'
          as='textarea'
          rows={3}
          defaultValue={formData.results}
          onChange={(e) => {
            handleChange("results", e.target.value);
          }}
          isInvalid={showValidationError && !formData.results}
        />
        {showValidationError && !formData.results && (
          <Form.Control.Feedback type='invalid' className='d-block'>
            Results are required.
          </Form.Control.Feedback>
        )}
      </Form.Group>
      <Form.Group>
        <Form.Label className='fs-6 fw-semibold'>Comments:</Form.Label>
        <Form.Control
          as='textarea'
          rows={3}
          defaultValue={formData.comments}
          onChange={(e) => {
            handleChange("comments", e.target.value);
          }}
        />
      </Form.Group>
    </>
  );
};

export default LabResultForm;
